import React from 'react';
import { CheckCircle, Shield } from 'lucide-react';

const VerifiedBadge = ({ size = 'sm', showText = true, variant = 'default' }) => {
  const sizeClasses = {
    xs: 'text-xs px-2 py-0.5',
    sm: 'text-xs px-2 py-1',
    md: 'text-sm px-3 py-1.5',
    lg: 'text-base px-4 py-2'
  };

  const iconSizes = {
    xs: 'w-3 h-3',
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5'
  };

  // Premium JAMOH theme colors
  const variantClasses = {
    default: 'bg-green-600/20 border-green-600 text-green-400',
    blue: 'bg-blue-600/20 border-blue-600 text-blue-400',
    premium: 'bg-gradient-to-r from-green-600/20 to-blue-600/20 border-green-600 text-green-400'
  };

  return (
    <div
      className={`
        inline-flex items-center space-x-1.5 
        ${sizeClasses[size]} 
        ${variantClasses[variant]}
        border rounded-sm font-medium
        backdrop-blur-sm
      `}
      title="This dealer has been verified by JAMOH & CO AUTOS LTD"
    >
      <CheckCircle className={`${iconSizes[size]} flex-shrink-0`} />
      {showText && <span>Verified Dealer</span>}
    </div>
  );
};

export default VerifiedBadge;
